import { useState, type FC, type ImgHTMLAttributes } from "react"

import { cn } from "../../../assets/Utils/generic"

import imageFallback from "../../../assets/img/directsearch/image_fallback.png"

type ImageWithFallbackProps = Omit<ImgHTMLAttributes<HTMLImageElement>, "onError">

const ImageWithFallback: FC<ImageWithFallbackProps> = ({ src, className, ...props }) => {
  const [imageSrc, setImageSrc] = useState(src)
  
  return (
    <img src={imageSrc} onError={() => setImageSrc(imageFallback)} className={cn("bg-[#E7E9EC]", className)} {...props} />
  )
}

export default ImageWithFallback